import { render, staticRenderFns } from "./recvItemAddItemsPopover.vue?vue&type=template&id=a5e10632&"
import script from "./recvItemAddItemsPopover.vue?vue&type=script&lang=js&"
export * from "./recvItemAddItemsPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports